module.exports = __webpack_public_path__ + "static/alfa-insurence-53d7f70e47367905e59b8f2a42867951.svg";